module.exports = __webpack_public_path__ + "static/wieczfnia_koscielna-678c8b193295d239103555839da3abdf.png";